"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OsobaResult = exports.FormLabel = exports.FormHeader = exports.FormButtonsWrap = exports.Field = void 0;
var Field_1 = require("./Field");
Object.defineProperty(exports, "Field", { enumerable: true, get: function () { return __importDefault(Field_1).default; } });
var FormButtonsWrap_1 = require("./FormButtonsWrap");
Object.defineProperty(exports, "FormButtonsWrap", { enumerable: true, get: function () { return __importDefault(FormButtonsWrap_1).default; } });
var FormHeader_1 = require("./FormHeader");
Object.defineProperty(exports, "FormHeader", { enumerable: true, get: function () { return __importDefault(FormHeader_1).default; } });
var Label_1 = require("./Label");
Object.defineProperty(exports, "FormLabel", { enumerable: true, get: function () { return __importDefault(Label_1).default; } });
var OsobaResult_1 = require("./OsobaResult");
Object.defineProperty(exports, "OsobaResult", { enumerable: true, get: function () { return __importDefault(OsobaResult_1).default; } });
